import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'
import EmailVerificationButtonLabel from './EmailVerificationButtonLabel'
import EmailVerificationEmailRow from './EmailVerificationEmailRow'
import { isVerifyPrimaryDescriptionShown } from '../../../utils/emailVerificationQA'
import useEmailVerificationQASetting from '../../../utils/emailVerification/useEmailVerificationQASetting'

const EmailVerificationPrimaryOffer = (props) => {
  const {
    email, onSendCode, onDifferentEmail, onRemindLater, sendCodeLoading,
    errorMessage,
  } = props
  // toggleable from the QA panel (hidden by default)
  const showDescription = useEmailVerificationQASetting(isVerifyPrimaryDescriptionShown)

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration />
      <div className='emailVerificationFlow-title'>Please verify your email address</div>
      {showDescription && (
        <div className='emailVerificationFlow-description'>
          A verified email address makes it easier to regain access to your Plickers account if you forget your password.
        </div>
      )}
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Email address</div>
        <EmailVerificationEmailRow
          email={email}
          onEdit={onDifferentEmail}
          editAriaLabel='Update email address'
        />
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      <button
        type='button'
        className='btn btn--blue btn--large'
        onClick={onSendCode}
        disabled={sendCodeLoading}
      >
        <EmailVerificationButtonLabel label='Verify' loading={sendCodeLoading} />
      </button>
      <div className='emailVerificationFlow-primaryOffer-links'>
        <button
          type='button'
          className='emailVerificationFlow-linkBtn'
          onClick={onRemindLater}
        >
          Remind me later
        </button>
      </div>
    </div>
  )
}

export default EmailVerificationPrimaryOffer
